import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CallHistory from './pages/CallHistory';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CallProvider } from './context/CallContext';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <CallProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="calls" element={<CallHistory />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CallProvider>
    </AuthProvider>
  );
}

export default App;